import { Outlet as ReactRouterOutlet } from 'react-router-dom'

export { Outlet }

const Outlet = () => <ReactRouterOutlet />
